import * as React from 'react';
import { _values } from '@epihub/core/src/fn/object';
import { LEGACY_THEMES, styled } from '../theme/theme';
import { cssFillHeightByPercentage, cssGlobal, globalTransitionTime } from './css';

export const ThemedBackground = () => {
  return (
    <FullDocumentHeight>
      <LockHeight>
        {_values(LEGACY_THEMES).map((theme) => (
          <BackgroundImage
            key={`${theme.id}-background-image`}
            apply={theme}
            style={{ backgroundImage: `url(${theme.backgroundImage})` }}
          />
        ))}
        {_values(LEGACY_THEMES).map((theme) => (
          <BackgroundTheme
            key={`${theme.id}-background-color`}
            apply={theme}
          />
        ))}
      </LockHeight>
    </FullDocumentHeight>
  );
};

const FullDocumentHeight = styled.div`
  ${cssGlobal};
  ${cssFillHeightByPercentage};
  position: absolute;
`;

const LockHeight = styled.div`
  ${cssFillHeightByPercentage};
  position: relative;
`;

const LockContent = styled.div`
  -ms-transition: opacity ${globalTransitionTime} ease;
  -webkit-transition: opacity ${globalTransitionTime} ease;
  transition: opacity ${globalTransitionTime} ease;
  
  ${cssFillHeightByPercentage};
  display: flex;
  flex: 1;
  flex-direction: column;
  left: 0;
  position: absolute;
  top: 0;
  width: 100%;
`;

type TApplyThemeProps = {
  apply: any;
};

const BackgroundImage = styled(LockContent)<TApplyThemeProps>`
  background-position: center center;
  background-repeat: no-repeat;
  background-size: cover;
  opacity: ${({ theme, apply }: any) => (theme.legacy.id === apply.id ? 1 : 0)};
`;

const BackgroundTheme = styled(LockContent)<TApplyThemeProps>`
  background: ${({ apply }: TApplyThemeProps) => apply.background};
  opacity: ${({ theme, apply }) => (theme.legacy.id === apply.id ? 1 : 0)};
`;
